module.exports = {"components.errorMessage.message.default":"予期しないエラーが発生しました。","components.errorMessage.reload.buttonLabel":"リロード","components.errorMessage.message.contentItem1":"してください","components.errorMessage.message.contentItem2":"ページ"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/components/ErrorMessage.json
// module id = 829
// module chunks = 0